var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"screen"}},[_c('h1',[_vm._v("You Won")]),_c('br'),_c('button',{on:{"click":_vm.Continue}},[_vm._v("Join the Leaderboard")])])}
var staticRenderFns = []

export { render, staticRenderFns }